import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { withTranslation } from 'react-i18next';

class WrappedTextField extends Component {

    render() {
        return (
            <TextField
                autoFocus={this.props.autoFocus}
                disabled={this.props.disabled}
                type={this.props.type}
                label={this.props.t(this.props.label)}
                id={this.props.name}
                name={this.props.name}
                onChange={(e) => this.props.onChange(e)}
                value={this.props.value}
                variant="outlined"
                margin="dense"
                fullWidth
                multiline={this.props.multiline}
                rows={this.props.multiline && 6}
                InputProps={this.props.InputProps}
                required={this.props.required}
                onKeyPress={this.props.onKeyPress ? (e) => this.props.onKeyPress(e) : null}
            />
        );
    }
}

export default withTranslation()(WrappedTextField);
